import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommReeferList extends Layout {
    layoutheaderTitle: LayoutHeader;
    sourceReefer: DataSource;
    tableMCReefer: Table;
}
